export const API_VERSION = (process.env.VUE_APP_IS_GENESIS === 'true') ? 'v2' : 'v1';